import { createContext, useCallback, useContext, useEffect, useState } from "react"
import { listAccounts, updateAccountPositions } from "./ApiInterface"

interface AccountsContextValue {
    accounts: Account[]
    loaded: boolean
    // À appeler après un changement des opérations : le menu affiche le reste à catégoriser.
    reloadAccounts: () => Promise<void>
    // Ordre choisi par glisser-déposer dans le menu, appliqué tout de suite puis enregistré.
    sortAccounts: (ids: number[]) => Promise<void>
}

const AccountsContext = createContext<AccountsContextValue>({
    accounts: [],
    loaded: false,
    reloadAccounts: () => Promise.resolve(),
    sortAccounts: () => Promise.resolve()
})

export const AccountsProvider = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
    const [accounts, setAccounts] = useState([] as Account[])
    const [loaded, setLoaded] = useState(false)

    const reloadAccounts = useCallback(() => listAccounts().then((accounts) => {
        setAccounts(accounts)
        setLoaded(true)
    }), [])

    // API injoignable au chargement : menu vide plutôt qu'une promesse rejetée sans catch
    useEffect(() => { reloadAccounts().catch((e) => console.warn('Comptes non chargés', e)) }, [reloadAccounts])

    const sortAccounts = useCallback((ids: number[]) => {
        setAccounts((accounts) => [...accounts].sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id)))
        return updateAccountPositions(ids).then(() => {}, reloadAccounts)
    }, [reloadAccounts])

    return <AccountsContext.Provider value={{ accounts, loaded, reloadAccounts, sortAccounts }}>
        { children }
    </AccountsContext.Provider>
}

export const useAccounts = () => useContext(AccountsContext)
